import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=04989f59"
import script from "./GroupManagement.vue?vue&type=script&lang=js"
export * from "./GroupManagement.vue?vue&type=script&lang=js"
import style0 from "./GroupManagement.vue?vue&type=style&index=0&id=04989f59&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports